export class RegisterUserDTO {
  firstname = ''
  lastname = ''
  phone = ''
  email = ''
  gender = ''
  birthday = ''
  password = ''
  passwordConfirmation = ''
  captchaToken = ''
  customerReferrer = ''

  // address
  street = ''
  streetnumber = ''
  zip = ''
  city = ''
  countryId = 0

  tShirtSize = ''

  validate () {
    if (
      !this.firstname ||
      !this.lastname ||
      !this.email ||
      !this.phone ||
      !this.gender ||
      !this.birthday ||
      !this.password ||
      !this.passwordConfirmation ||
      !this.customerReferrer ||
      !this.captchaToken ||
      !this.countryId
    ) {
      return 'Bitte fülle alle Felder aus!'
    }

    if (this.password !== this.passwordConfirmation) {
      return 'Password stimmt nicht mit Password Kontrolle überein!'
    }

    if (this.password.length < 8) {
      return 'Bitte ein Passwort mit >8 Zeichen wählen'
    }

    if (
      !this.email.match( // eslint-disable-next-line
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      )
    ) {
      return 'Bitte gib eine korrekte E-Mail Adresse an'
    }

    return ''
  }
}
